const STORE_KEY = 'SIDEBAR_MENU'

export const FETCH_SIDEBAR_MENU = `${STORE_KEY}/FETCH_SIDEBAR_MENU`
export const UPDATE_SIDEBAR_MENU_AFTER_SIGN_IN = `${STORE_KEY}/UPDATE_SIDEBAR_MENU_AFTER_SIGN_IN`
export const UPDATE_SIDEBAR_MENU_AFTER_SIGN_OUT = `${STORE_KEY}/UPDATE_SIDEBAR_MENU_AFTER_SIGN_OUT`
